import Application from '@ember/application'
import SpinnakerExtensionHandlerService from 'customer-flows/services/extensions/extension-handler'
import SpinnakerExtensionEventsService from 'customer-flows/services/extensions/extension-events'
import SpinnakerExtensionLoaderService from 'customer-flows/services/extensions/extension-loader'
import SpinnakerPeekExtensionsAPIService from 'customer-flows/services/extensions/extensions-api'

export function initialize (application: Application): void {
  application.register('service:extensions/extension-events', SpinnakerExtensionEventsService, { instantiate: true })
  application.register('service:extensions/extension-handler', SpinnakerExtensionHandlerService, { instantiate: true })
  application.register('service:extensions/extensions-api', SpinnakerPeekExtensionsAPIService, { instantiate: true })
  application.register('service:extensions/extension-loader', SpinnakerExtensionLoaderService, { instantiate: true })
}

export default {
  name: 'extensions',
  initialize
}
